<template>
  <v-container fluid>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card color="#F3F5F8">
        <v-card-title>
          <h4 class="titleText--text">Access settings for {{ this.username }}</h4>
          <v-spacer />
          <v-btn icon @click="closeForm()">
            <v-icon color="titleText">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-btn-toggle v-model="dataMapping" mandatory borderless  color="#51A7F8">
              <v-btn small>
                <span class="text-capitalize font-weight-bold">
                  Data mapping
                </span>
              </v-btn>
              <v-btn small @click="openappmapingdliog()">
                <span class="text-capitalize font-weight-bold">
                  App mapping
                </span>
              </v-btn>
            </v-btn-toggle>
            <v-simple-table dense v-show="!dataMapping" class="mt-5">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left titleText--text font-weight-bold">Data</th>
                    <th class="text-left titleText--text font-weight-bold">Have Acess</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(items) in listuserdatanew"
                    :key="items.display"
                  >
                    <td class="text-left titleText--text font-weight-bold">{{ items.display }}</td>
                    <td class="text-right">
                      <v-checkbox
                       v-model="items.isassign"
                       color="#2CD8C5"
                        @change="
                          OnMappingChange($event, items.display, items.mappid)
                        "
                      ></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <appMapping ref="ctrluserappmapp" v-show="dataMapping" class="mt-5"/>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import apifactory from "../api";
import appMapping from "./UserAppMapping.vue";
export default {
  props: ['id', 'name'],
  components: {
    appMapping
  },
  data() {
    return {
      dialog: false,
      username: "",
      listuserdata: [],
      listuserdatanew: [],
      listusermappdata: [],
      userid: 0,
      dataMapping: false,
    };
  },
  mounted() {},
  computed: {},
  methods: {
    openappmapingdliog() {
      this.$refs.ctrluserappmapp.OnloadCall(this.id, this.name);
    },
    OnMappingChange(event, vardataid, varmappid) {
      if (event) {
        if (varmappid != 0) {
          this.showAlertConfirmForReMapp(vardataid);
        } else {
          this.showAlertConfirmForMapp(vardataid);
        }
      }
      if (!event) {
        this.showAlertConfirmForUnMapp(vardataid);
      }
    },
    showAlertConfirmForMapp(vardataid) {
      this.$swal({
        title: "Are you sure?",
        text: "Are you want to mapp this!",
        type: "success",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, mapp it!",
      }).then((result) => {
        if (result.value) {
          this.mappuserdata(vardataid,this.userid);
        }
      });
    },
    showAlertConfirmForUnMapp(varmappid) {
      this.$swal({
        title: "Are you sure?",
        text: "Are you want to unmapp this!",
        type: "success",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, unmapp it!",
      }).then((result) => {
        if (result.value) {
          this.unmappuserdata(varmappid);
        }
      });
    },
    showAlertConfirmForReMapp(vardataid) {
      this.$swal({
        title: "Are you sure?",
        text: "Are you want to mapp this!",
        type: "success",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, unmapp it!",
      }).then((result) => {
        if (result.value) {
          this.remappuserdata(vardataid);
        }
      });
    },
    mappuserdata(vardataid,varuserid) {
      apifactory
        .apicall_get_mappuserdata(varuserid, vardataid)
        .then((res) => {
          JSON.stringify(res);
          // alert(res.data.message);
          this.$swal("User Mapp", res.data.message, "success");
          this.loaduserdata();
        })
        .catch(function (error) {
          this.$swal("Sorry", error, "error");
        });
    },
    unmappuserdata(vardataid) {
      //alert(varmappid);
      apifactory
        .apicall_get_unmappuserdata( this.userid, vardataid)
        .then((res) => {
          //alert(JSON.stringify(res));
           this.$swal("Done", res.data.message, "success");
          this.loaduserdata();
        })
        .catch(function (error) {
          this.$swal("Sorry", error, "error");
        });
    },
    remappuserdata(vardataid) {
      //  alert(varmappid);
      apifactory
        .apicall_get_remappuserdata(this.userid, vardataid)
        .then((res) => {
           this.$swal("Done", res.data.message, "success");
          this.loaduserdata();
        })
        .catch(function (error) {
           this.$swal("Sorry", error, "error");
          console.warn(error);
        });
    },
    OnloadCall(varuserid, varusername) {
      //alert(varuserid);
      this.dialog = true;
      this.username = varusername;
      this.userid = varuserid;
      //  alert('ddd');

      this.loaduserdata();
    },
    closeForm() {
      this.dialog = false;
      this.dataMapping = false
      this.$parent.reloadfromchild();
    },
    loaduserdata() {
      apifactory
        .apicall_get_available_data()
        .then((res) => {
          // alert(JSON.stringify(res));
          if (res.status != 200) {
            this.listuserdata = null;
            // alert(this.processdataitems.length);
          } else {
            this.listuserdata = res.data;
           
            
            this.loadusermappdata();
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
    loadusermappdata() {
      this.listusermappdata=[];
      apifactory
        .apicall_get_available_databyuser(this.userid)
        .then((res) => {
          // alert(JSON.stringify(res));
          if (res.status != 200) {
            this.listusermappdata = null;
            // alert(this.processdataitems.length);
          } else {
            this.listusermappdata = res.data;
             this.listuserdatanew=[];
             /*
            for (let element in this.listusermappdata) {
              
              if (element == "data") {
           
                for (let datae in this.listuserdatanew) {
                  
                 

                  if (
                    this.listuserdatanew[datae].display ==
                    this.listusermappdata.data
                  ) {
                  
                   this.listuserdatanew[datae].ismap = 1;
                  }
                }
              }
             
            }*/

            for(let e in this.listuserdata)
            {
               let obj=new Object;
               obj=this.listuserdata[e];
                obj.isassign=false;
                obj.mappid=0;
               for(let i in this.listusermappdata)
               {
                //alert(JSON.stringify(this.listusermappdata[i]));
                //alert(JSON.stringify(this.listusermappdata[i].data));
                if( this.listuserdata[e].display ==
                    this.listusermappdata[i].data)
                    {
                      obj.isassign=true;
                       obj.mappid=this.listusermappdata[i].id;
                    }
               }
               this.listuserdatanew.push(obj);
              
            }

            
          }
        })
        .catch(function (error) {
          console.warn(error);
        });
    },
  },
};
</script>

<style scoped>
.inactive-bg {
  color: red;
}

.inactive-bg-green {
  color: green;
}

.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:not(:last-child)
  > td:not(.v-data-table__mobile-row) {
  border-color: white !important;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr > th {
  border-color: white !important;
  background-color: white !important;
}
</style>
